import { render, staticRenderFns } from "./set-alarm.vue?vue&type=template&id=57cd3afa"
import script from "./set-alarm.vue?vue&type=script&lang=js"
export * from "./set-alarm.vue?vue&type=script&lang=js"
import style0 from "./set-alarm.vue?vue&type=style&index=0&id=57cd3afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports